import * as MuiFormHelperText from '@mui/material/FormHelperText'
import React from 'react'

export type FormHelperTextProps = MuiFormHelperText.FormHelperTextProps

export function FormHelperText({ children, ...props }: FormHelperTextProps) {
  return (
    <MuiFormHelperText.default {...props}>{children}</MuiFormHelperText.default>
  )
}
